import React, { useState, useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import { withRouter } from 'react-router-dom';
import numeral from 'numeral';
import moment from 'moment';

import { useTheme } from '@material-ui/core/styles';

import { advertiserMonthData } from 'lib/api/report';
import { setNumberFormat } from 'lib/commonLib';

import CurrentStatus from 'components/atoms/CurrentStatus';
import ContentsWrap from 'components/molecules/ContentsWrap';
import InfoTitleArea from 'components/molecules/MbTable/InfoTitleArea';
import Highchart from 'components/organisms/Chart/Highchart';
import SwitchingArea from 'components/organisms/SwitchingArea';

const StatisticsGraph = (props) => {
  const { handleClickSnackbar } = props;
  const { t } = useTranslation();
  const theme = useTheme();

  const initOptions = {
    chart: {
      type: 'pie',
      height: 300,
      backgroundColor: theme.palette.common.bgColor,
    },
    title: { text: 'init title', fontSize: '12px' },
    credits: { enabled: false },
    xAxis: { type: 'category' },
    tooltip: {
      formatter: function () {
        let sHtml = '';
        sHtml +=
          this.key +
          '<br/>' +
          this.point.title +
          // setNumberFormat(this.total, 'integer', '0,0') +
          ': <b>' +
          setNumberFormat(this.y, 'integer', '0,0') +
          '</b>';
        return sHtml;
      },
      shared: true,
    },
    plotOptions: {
      pie: {
        cursor: 'pointer',
        dataLabels: {
          enabled: true,
          format: '<b>{point.name}</b>: {point.percentage:.1f} %',
        },
      },
    },
    series: [],
  };

  const [graphOption, setGraphOption] = useState({
    ADVER_CNT: initOptions,
    ADVRTS_AMT: initOptions,
    AMT_ADVER_CNT: initOptions,
    MTH_ADVER_CNT: initOptions,
  });
  const [infoMessage, setInfoMessage] = useState('');
  const [viewState, setViewState] = useState('');
  const graphList = [
    'ADVER_CNT',
    'ADVRTS_AMT',
    'AMT_ADVER_CNT',
    'MTH_ADVER_CNT',
  ];

  useEffect(() => {
    getData();
    // eslint-disable-next-line
  }, []);

  /**
   * 그래프 데이터를 받아온다.
   */
  const getData = () => {
    const sDate = moment().add(-1, 'month');
    const eDate = moment().add(-1, 'day');
    setViewState('loading');
    setInfoMessage(
      t(
        '까지의 기간 중, 광고주별 합계 15만원 이상 지출된 내 광고주 데이터 그래프입니다.',
        {
          date: t('term', {
            startDate: sDate.format('YYYY-MM-DD'),
            endDate: eDate.format('YYYY-MM-DD'),
          }),
        }
      )
    );
    advertiserMonthData({
      sDate: sDate.format('YYYYMMDD'),
      eDate: eDate.format('YYYYMMDD'),
      conditionKey: 'advrtsAmt',
      conditionVal: 150000,
      Inequality: '01',
    })
      .then((response) => {
        const { data } = response.data;
        let newData = graphOption;
        for (let key in data) {
          let newTitle = '';
          let newOptionData = [];

          if (key === 'ADVER_CNT') {
            newTitle = t('광고주 수');
          } else if (key === 'ADVRTS_AMT') {
            newTitle = t('지출금액');
          } else if (key === 'AMT_ADVER_CNT') {
            newTitle = t('지출금액별 광고주 수');
          } else if (key === 'MTH_ADVER_CNT') {
            newTitle = t('최근 30일 신규 광고주 수');
          }

          for (let aaa of data[key]['data']) {
            newOptionData.push({
              name: aaa['name'],
              y: aaa['value'],
              title: newTitle,
            });
          }

          newData = {
            ...newData,
            [key]: {
              ...newData[key],
              title: {
                text: newTitle + ' : ' + numeral(data[key]['total']).format(),
              },
              series: [
                {
                  name: newTitle,
                  colorByPoint: true,
                  data: newOptionData,
                },
              ],
            },
          };
          setGraphOption(newData);
        }
      })
      .catch((error) => {
        setViewState('error');
        handleClickSnackbar({ message: error, option: { type: 'error' } });
      })
      .finally(() => {
        setViewState('');
      });
  };

  /**
   * 새로고침
   */
  const handleRefesh = () => {
    getData();
  };

  return (
    <>
      <SwitchingArea
        title={
          <InfoTitleArea
            title={t('광고주 통계 그래프')}
            tooltipTitle={infoMessage}
            iconType="fainfoCircle"
            iconColor="graph"
          />
        }
        handleRefesh={handleRefesh}
        graphData
        isOpen={false}
      >
        <>
          {viewState !== '' ? (
            <CurrentStatus type={viewState} />
          ) : (
            <ContentsWrap contentsCount={4}>
              {graphList.map((key, index) => {
                return <Highchart options={graphOption[key]} key={index} />;
              })}
            </ContentsWrap>
          )}
        </>
      </SwitchingArea>
    </>
  );
};

export default withRouter(StatisticsGraph);
